import { Badge } from "@mantine/core";
import { semanticColor, type SemanticRole } from "@how/design-system";
import { PLAN_LABEL, type PlanKey } from "./plans";

/** Core is neutral, Pro carries the brand, Elite the achievement role: a real ranking (ADR 0055). */
const ROLE: Readonly<Record<PlanKey, SemanticRole>> = {
  core: "neutral",
  pro: "brand",
  elite: "achievement",
};

export function PlanBadge({
  plan,
  size = "sm",
}: {
  readonly plan: PlanKey;
  readonly size?: "sm" | "lg";
}) {
  return (
    <Badge variant="light" color={semanticColor(ROLE[plan])} size={size} data-plan={plan}>
      {PLAN_LABEL[plan]}
    </Badge>
  );
}
